<template>
    <div class="mt-lg">
        <a
            class="btn text-sm is-primary"
            @click="$modal.show('delete-lead')"
        >
            Markera som hanterad
        </a>
        <adaptive-form-modal
            name="delete-lead"
            primary-button-text="Markera som hanterad"
            title="Markera som hanterad"
            :redirect-to="redirectRoute"
            method="delete"
            :action="actionRoute"
        >
            <p class="leading-normal">
                Vill du verkligen markera denna intresseanmälan som hanterad?
                All kundinformation som tillhör intresseanmälan kommer att försvinna.
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            lead: {
                type: Object,
                required: true,
            },
            project: {
                type: Object,
                required: true,
            },
            address: {
                type: Object,
                required: true,
            },
        },

        computed: {
            actionRoute() {
                return route('api.leads.destroy', [this.lead]);
            },
            redirectRoute() {
                return route('admin.sales-projects.addresses.show', [this.project, this.address]);
            },
        },
    };
</script>
